import Input from "core/components/Input"
import StandardSelect from "core/components/v2/StandardSelect"
import DashboardLayout from "core/layouts/DashboardLayout"
import useAlumniViewModel from "./AlumniViewModel"
import Button from "core/components/new/Button"

const AlumniView = () => {
  const { handleAlumniMentorSessions, handleAlumniEmailsChange, inputEmails, loading } = useAlumniViewModel()

  return (
    <DashboardLayout>
      <div className="p-6">
        <div className="w-full">
          <h1 className="text-2xl font-bold leading-[29px] text-new-accent">Download Mentor Sessions of Alumni</h1>
          <p className="font-medium">Dowload Mentor Session for a Group of Alumni</p>
        </div>
        <div className="flex justify-center py-12">
          <div className="round-2 flex w-full max-w-xl flex-col items-center p-6 shadow-[0px_4px_16px_rgba(32,76,188,0.2)]">
            <Input
              type="textarea"
              placeholder="Email's Of Alumni"
              onChange={handleAlumniEmailsChange}
              value={inputEmails}
              className=""
            />
            <Button className="mt-4" onClick={() => handleAlumniMentorSessions(inputEmails)}>
              {loading ? "Downloading..." : "Download Alumni Mentor Sessions"}
            </Button>
          </div>
        </div>
      </div>
    </DashboardLayout>
  )
}

export default AlumniView
